export var home = '/';
export var notifications = '/notifications';